/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  HookTraceSummary,
  HookTraceSummary$inboundSchema,
} from "./hooktracesummary.js";

/**
 * Result of listing hook traces
 */
export type ListHooksTracesResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * List of hook trace summaries
   */
  traces: Array<HookTraceSummary>;
};

/** @internal */
export const ListHooksTracesResult$inboundSchema: z.ZodMiniType<
  ListHooksTracesResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    traces: z.array(HookTraceSummary$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listHooksTracesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListHooksTracesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListHooksTracesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListHooksTracesResult' from JSON`,
  );
}
